import type { LandingPage, LandingPageSubmission } from "./FakeLandingPage";

export type SmishingChannel = "sms" | "whatsapp" | "slack" | "teams" | "telegram" | "instagram" | "linkedin";
export type SmishingRequestCategory = "address" | "verificationCode" | "email" | "phone" | "referenceNumber" | "employeeId" | "fullName" | "department" | "username" | "password";

export interface SmishingApiMessage {
  role: "user" | "assistant";
  content: string;
}

export interface SmishingChatInitResponse {
  success?: boolean;
  firstMessage?: string;
  isFinished?: boolean;
  otpCode?: string;
  otpSender?: string;
  landingPage?: LandingPage;
  expectedResponseCategory?: SmishingRequestCategory;
  error?: string;
}

export interface SmishingChatReplyResponse {
  success?: boolean;
  reply?: string;
  replies?: string[];
  isFinished?: boolean;
  otpCode?: string;
  otpSender?: string;
  landingPage?: LandingPage;
  expectedResponseCategory?: SmishingRequestCategory;
  error?: string;
}

export function buildSmishingInitRequest(
  microlearningId: string,
  language: string,
  channel: SmishingChannel
) {
  return {
    microlearningId,
    language,
    channel,
  };
}

export function buildSmishingMessageRequest(params: {
  microlearningId: string;
  language: string;
  channel: SmishingChannel;
  messages: SmishingApiMessage[];
  pendingOtp?: { code: string; sender: string } | null;
  pendingLandingPageSubmission?: LandingPageSubmission | null;
  pendingClickedLink?: string | null;
}) {
  const {
    microlearningId,
    language,
    channel,
    messages,
    pendingOtp,
    pendingLandingPageSubmission,
    pendingClickedLink,
  } = params;

  return {
    microlearningId,
    language,
    channel,
    messages,
    ...(pendingOtp ? { pendingOtpCode: pendingOtp.code, pendingOtpSender: pendingOtp.sender } : {}),
    ...(pendingLandingPageSubmission ? { pendingLandingPageSubmission } : {}),
    ...(pendingClickedLink && !pendingLandingPageSubmission ? { pendingClickedLink } : {}),
  };
}
